// Domain module extracted from lib/api.ts (frontend containment F1).
// Moved verbatim: endpoint paths, methods, payloads, parsing, types and export names
// are unchanged. Import via lib/api.ts, which re-exports this module.
import { request } from './client';

export const getDealtonFundQa = () =>
  request<{ active: boolean; replay_owner: string | null }>('/super-admin/dealton-fund-qa');
export const replayDealtonFundOnboarding = () =>
  request<{ ok: boolean; replay_owner: string }>('/super-admin/dealton-fund-qa/replay',
    { method: 'POST' });
export const releaseDealtonFundOnboarding = () =>
  request<{ ok: boolean; previous_owner: string | null }>('/super-admin/dealton-fund-qa/release',
    { method: 'POST' });

// ── Super Admin ────────────────────────────────────────────────────────
export interface SuperAdminOrg {
  company: string;
  trial_start: string;
  trial_end: string;                       // empty if not on trial
  trial_days_remaining: number | null;     // null if not on trial
  tier: string;
  subscription_ends_at: string;
  user_count: number;
}
export const listAllOrgs = (start?: string, end?: string, limit = 200, offset = 0) => {
  const qs = new URLSearchParams();
  if (start) qs.set('start', start);
  if (end) qs.set('end', end);
  qs.set('limit', String(limit));
  qs.set('offset', String(offset));
  return request<{ orgs: SuperAdminOrg[]; count: number }>(`/super-admin/orgs?${qs}`);
};
export interface SuperAdminUser { email: string; name: string; is_admin: boolean; }
export const listOrgUsers = (company: string) =>
  request<{ users: SuperAdminUser[] }>(`/super-admin/orgs/${encodeURIComponent(company)}/users`);

export const startSupportView = (company: string, userEmail: string) =>
  request<{ token: string; company: string; target_email: string; expires_at: number }>(
    '/super-admin/view-as', {
      method: 'POST',
      body: JSON.stringify({ company, user_email: userEmail, reason: 'Super Admin support view' }),
    },
  );

export interface UsageBucket { count_30d: number; count_all: number; last_ts: string; }
export interface StrafeBucket { jobs_30d: number; jobs_all: number; total_recipients_all: number; last_ts: string; }
export interface UserUsageStats {
  chat: UsageBucket;
  prospecting: UsageBucket;
  strafe: StrafeBucket;
  email_client: UsageBucket;
  last_activity: string;
}
export const getUserUsage = (company: string, email: string) =>
  request<UserUsageStats>(
    `/super-admin/orgs/${encodeURIComponent(company)}/users/${encodeURIComponent(email)}/usage`,
  );

export interface OrgUsageBucket { count_7d: number; count_30d: number; count_all: number; last_ts: string; }
export interface OrgUsageStrafeBucket { jobs_7d: number; jobs_30d: number; jobs_all: number; total_recipients_all: number; last_ts: string; }
export interface OrgUsageActiveUsers { users_7d: number; users_30d: number; users_all: number; total_users: number; }
export interface OrgUsageStats {
  chat: OrgUsageBucket;
  prospecting: OrgUsageBucket;
  strafe: OrgUsageStrafeBucket;
  email_client: OrgUsageBucket;
  active_users: OrgUsageActiveUsers;
  last_activity: string;
}
export const getOrgUsage = (company: string) =>
  request<OrgUsageStats>(`/super-admin/orgs/${encodeURIComponent(company)}/usage`);

// Cross-tenant user delete. Returns `org_archived: true` when the removed
// user was the last one in the org, in which case the backend has also
// wiped all org data + GCS blobs (see admin._archive_org).
export const superAdminDeleteUser = (company: string, email: string) =>
  request<{ ok: boolean; org_archived: boolean }>(
    `/super-admin/orgs/${encodeURIComponent(company)}/users/${encodeURIComponent(email)}`,
    { method: 'DELETE' },
  );
